import { hasValue } from '@repo/utils';

export const getNumberWithDecimalPlaces = (
  value: number | null | undefined,
  decimalPlaces: number = 2,
): number | null => {
  if (!hasValue(value)) {
    return null;
  }

  if (Number.isNaN(Number(value))) {
    return null;
  }

  if ((!value && value !== 0) || Number.isNaN(Number(value))) return null;

  const multiplier = 10 ** decimalPlaces;

  return Math.round(value * multiplier) / multiplier;
};
